import { motion } from "framer-motion";
import { BookOpenCheck, Calendar, GraduationCap } from "lucide-react";
import { coursework } from "../data";

export default function Education() {
  return (
    <section id="education" className="section-shell">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 0.6 }}
        className="mx-auto max-w-3xl text-center"
      >
        <p className="text-sm font-bold uppercase tracking-[0.35em] text-cyan-200">Боловсрол</p>
        <h2 className="mt-4 font-display text-3xl font-black text-white sm:text-5xl">Боловсрол</h2>
      </motion.div>

      <div className="mt-12 grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
        <motion.div
          initial={{ opacity: 0, x: -26 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="glass-card relative overflow-hidden p-5 sm:p-8"
        >
          <div className="absolute bottom-0 left-6 top-8 w-px bg-gradient-to-b from-cyan-300 via-purple-300 to-transparent sm:left-8" />
          <div className="relative pl-8 sm:pl-10">
            <span className="absolute left-0 top-0 grid h-6 w-6 -translate-x-1/2 place-items-center rounded-full bg-cyan-300 shadow-glow">
              <span className="h-2.5 w-2.5 rounded-full bg-slate-950" />
            </span>
            <div className="mb-5 inline-flex items-center gap-2 rounded-full bg-cyan-300/10 px-3 py-1.5 text-xs font-bold text-cyan-100 sm:text-sm">
              <Calendar size={16} /> 2023 - Одоо
            </div>
            <h3 className="text-xl font-black leading-tight text-white sm:text-2xl">Шинжлэх Ухаан Технологийн Их Сургууль</h3>
            <p className="mt-3 text-base font-semibold text-cyan-100">Мэдээлэл, Холбооны Технологийн Сургууль</p>
            <p className="mt-2 text-slate-300">Бакалавр | Компьютерын ухаан</p>
            <p className="mt-4 inline-flex rounded-2xl border border-purple-300/25 bg-purple-300/10 px-4 py-2 text-sm font-black text-purple-100">
              GPA: 3.4
            </p>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 26 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
          className="glass-card p-5 sm:p-8"
        >
          <div className="mb-6 flex items-center gap-3">
            <span className="grid h-12 w-12 place-items-center rounded-2xl bg-white/[0.08] text-cyan-100">
              <GraduationCap size={25} />
            </span>
            <div>
              <h3 className="text-lg font-black text-white sm:text-xl">Суралцсан чиглэлүүд</h3>
              <p className="text-sm text-slate-400">Coursework & focus areas</p>
            </div>
          </div>

          <div className="grid gap-3 sm:grid-cols-2">
            {coursework.map((item) => (
              <div key={item} className="flex items-start gap-3 rounded-2xl border border-white/10 bg-white/5 p-4">
                <BookOpenCheck className="mt-0.5 shrink-0 text-cyan-200" size={18} />
                <span className="text-sm font-semibold leading-6 text-slate-200">{item}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
